module.exports = __webpack_public_path__ + "static/media/main_sub_icon.02c36b60.svg";